<template>
  <v-dialog v-model="dialog" max-width="800px">
    <div class="dialogBackground" :style="isMobile ? '' : 'padding: 80px'">
      <div class="titleText" :style="isMobile ? 'padding: 30px' : ''">
        Claim Prize
      </div>
      <div v-if="fetchingClaim" class="mt-8" style="text-align: center;">
        <v-progress-circular
          :size="70"
          :width="7"
          color="yellow"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-else-if="claimRequest" class="mt-8">
        <div class="subtitleText">
          Your claim has been completed! Thank you for playing Golden Moments.
        </div>
        <div>
          <v-btn
            class="yellowButton ma-0 mt-8"
            block
            depressed
            @click="dialog = false"
          >
            Done
          </v-btn>
        </div>
      </div>
      <v-row v-else-if="moment" class="my-8" justify="center" align="center">
        <v-col cols="6">
          <video
            :poster="moment.imageUrl"
            class="videoFrame"
            muted
            autoplay
            loop
          >
            <source :src="moment.videoUrl" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </v-col>
        <v-col cols="6">
          <div class="challengeName">
            {{ token.collectible.name }}
          </div>
          <div class="challengeTitle">
            {{ moment.name }}
          </div>
        </v-col>
        <v-col cols="12">
          <div>
            <div
              class="divider"
              style="margin-top: 40px; margin-bottom: 40px;"
            />
            <div style="margin-top: 40px; text-align: right;">
              <v-btn
                class="yellowButton"
                depressed
                :loading="loading"
                @click="submit()"
                block
              >
                Claim {{ moment.points }} GM Points
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  import Countries from '@/assets/countries';
  import ClaimRequestController from '@/controllers/ClaimRequestController';
  import { mapActions } from 'vuex';

  export default {
    name: 'CreateTokenListing',

    props: ['token', 'value', 'isMobile'],

    computed: {
      ...mapState({ tokens: (state) => state.tokens }),
      moment() {
        if (!this.token) {
          return null;
        }
        return this.token.moment;
      },
      claimStatus() {
        return true;
      },
      formValidated() {
        return (
          this.shippingInfo.firstName &&
          this.shippingInfo.lastName &&
          this.shippingInfo.address1 &&
          this.shippingInfo.country &&
          this.shippingInfo.state &&
          this.shippingInfo.city &&
          this.shippingInfo.postalCode &&
          this.shippingInfo.phoneNumber &&
          this.shippingInfo.emailAddress
        );
      },
    },

    data() {
      return {
        fetchingClaim: false,
        loading: false,
        dialog: this.value,
        shippingInfo: {},
        Countries,
        claimRequest: null,
      };
    },

    watch: {
      value: {
        handler(val) {
          this.dialog = val;
          if (val) {
            this.claimRequest = null;
            this.shippingInfo = {};
            this.fetchClaim();
          }
        },
      },
      dialog: function(val) {
        this.$emit('input', val);
      },
    },

    mounted: function() {},

    methods: {
      ...mapActions({ setUser: 'setUser' }),
      handleError: function(err) {
        this.$emit('handleError', err);
      },
      fetchClaim: async function() {
        this.fetchingClaim = true;
        try {
          this.claimRequest = await ClaimRequestController.getTokenClaim(
            this.token._id,
            this.shippingInfo
          );
        } catch (error) {
          console.log(error);
        } finally {
          this.fetchingClaim = false;
        }
      },
      submit: async function() {
        this.loading = true;
        try {
          const {
            claimRequest,
            user,
          } = await ClaimRequestController.claimToken(
            this.token._id,
            this.shippingInfo
          );
          this.claimRequest = claimRequest;
          if (user) {
            this.setUser(user);
          }
        } catch (error) {
          this.$emit('handleError', error);
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .dialogBackground {
    background: #ffffff;
    border: 1px solid #9d9d9d;
    border-radius: 30px;
  }
  .titleText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 40px;
    /* or 100% */

    color: #000000;
  }

  .subtitleText {
    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    /* identical to box height, or 110% */

    color: #000000;
  }

  .challengeName {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #151515 !important;
  }
  .challengeTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    line-height: 32px !important;
    color: #151515 !important;
  }
  .challengeInfo {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    color: #151515 !important;
  }

  .fieldHeader {
    font-family: 'Work Sans' !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 22px !important;
    margin-bottom: 4px !important;
    color: #454c54 !important;
  }
</style>
